import { WebsiteCategories, WebsiteCategoryCookie } from '@/enums/app'
import { Middleware } from '@nuxt/types'
import { getCookieDomain } from '@/utils/cookie'
import { WomenCountries } from '@/enums/general'

const setWebsiteCategoryMiddleware: Middleware = ({ route, app, store }) => {
  const country = store.state.app.country

  if (WomenCountries.includes(country)) {
    if (route?.name && route?.name.includes('lang-')) {
      const pathName = route.name.replace('lang-', '')

      if (pathName === WebsiteCategories.men || pathName.startsWith(`${WebsiteCategories.men}-`) || pathName.startsWith('try-now')) {
        app.$cookies.set(WebsiteCategoryCookie, WebsiteCategories.men, { expires: new Date(Date.now() + 604800), path: '/', domain: getCookieDomain() })
      }

      if (pathName === WebsiteCategories.women || pathName.startsWith(`${WebsiteCategories.women}-`)) {
        app.$cookies.set(WebsiteCategoryCookie, WebsiteCategories.women, { expires: new Date(Date.now() + 604800), path: '/', domain: getCookieDomain() })
      }
    }
  } else {
    app.$cookies.set(WebsiteCategoryCookie, WebsiteCategories.men, { expires: new Date(Date.now() + 604800), path: '/', domain: getCookieDomain() })
  }
}

export default setWebsiteCategoryMiddleware
